import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { Form } from 'antd';
import { useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';

import { drawingSetVersionFragment$key } from '../graphql/__generated__/drawingSetVersionFragment.graphql';
import { drawingSetVersionListFragment$key } from '../graphql/__generated__/drawingSetVersionListFragment.graphql';
import { getDrawingSetVersionListQuery as getDrawingSetVersionListQueryType } from '../graphql/__generated__/getDrawingSetVersionListQuery.graphql';
import { getDrawingSetVersionListQuery } from '../graphql/query/get-drawing-set-version-list-query';

interface LoaderFormDrawingSetVersionProps {
    drawingSetId: string;
    versionDate: number;
}

export const LoaderFormDrawingSetVersion: React.FC<LoaderFormDrawingSetVersionProps> = ({
    drawingSetId,
    versionDate,
}) => {
    const form = Form.useFormInstance();

    const resultEntityList = useLazyLoadQuery<getDrawingSetVersionListQueryType>(
        getDrawingSetVersionListQuery,
        {
            input: {
                filter: {
                    drawingSetId: {
                        operator: 'EQ',
                        value: drawingSetId,
                    },
                    versionDate: {
                        operator: 'EQ',
                        value: versionDate.toString(),
                    },
                },
            },
            first: 1,
        },
        { fetchPolicy: 'store-or-network', fetchKey: 'oneDrawingSetVersion' },
    );

    const data = useFragmentFromStore<drawingSetVersionListFragment$key>(resultEntityList);
    const dataResult = useFragmentFromStore<drawingSetVersionFragment$key>(data.drawingSetVersionList?.edges[0]?.node);

    useEffect(() => {
        form.setFieldsValue({ versionDate: dataResult.id });
    }, [data]);

    return null;
};
